/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { GetProjectsProjectidOptions, GetProjectsProjectidResponses } from '../types/GetProjectsProjectid'
import { client, withUnwrap } from '../.kubb/client'

/**
 * {@link /projects/:projectId}
 */
export function getProjectsProjectid<ThrowOnError extends boolean = true>(options: Options<GetProjectsProjectidOptions, ThrowOnError>): Unwrappable<RequestResult<GetProjectsProjectidResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(request({ method: 'GET', url: '/projects/{projectId}', security: [{ type: 'http', scheme: 'bearer' }], ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetProjectsProjectidResponses, ThrowOnError>>)
}
